// extracted by mini-css-extract-plugin
export default {"removalBlockArea":"BlockRemovalArea_removalBlockArea__P1b-K","isActive":"BlockRemovalArea_isActive__AmSnc"};